import { Component, Input, OnInit, Output, EventEmitter, ViewChild, SimpleChanges, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Calendar } from 'primeng/calendar';
import { DatePipe } from '@angular/common';
import { thousands_separators, thousands_separatorsd } from '../../utils/utilities.function';
import { DefaultService } from '../../../app/utils/default.service';
import { MessageService } from 'primeng/api';
import { Table } from 'primeng/table';

@Component({
   selector: 'app-merge-table',
   templateUrl: './merge-table.component.html',
   styleUrls: ['./merge-table.component.scss'],
   changeDetection: ChangeDetectionStrategy.OnPush
})
export class MergeTableComponent implements OnInit {
   @ViewChild('dt', { static: false }) dt!: Table;
   
   @Input() isLoading: boolean = false;
   @Input() tableSchema: any;
   @Output() editInParent = new EventEmitter();
   @Input() headerSelectOptions: any;
   @Input() opsFilterOptions: any = {
		signOffStatusIndicator: [] as any[], sign_off_status: [] as any[], recon_status: [] as any[], ddFilters: [] as any[], ops_fund_type: [] as any[], 
		custodianReconParty: [] as any[], exception_status: [] as any[], fundGroup: [] as any[], nav_frequency: [] as any[], sla_type: [] as any[], sla_met: [] as any[], 
		entity: [] as any[], custodian_recon_party: [] as any[], fund_class: [] as any[], tradeFillDay: [] as any[], dealingDateIndicator: [] as any[], dcCalcType: [] as any[]
	};

   // Table data variables
   @Input() tableData: any[] = [];
   copyTableData: any = [];

   // Selected Rows variables
   selectedRows: any[] = []; // The table is at this child component, so only do selection handling here
   @Input() isClearSelectedRows: boolean = false; // Flag to clear selected rows, sent from parent
   @Output() childEmitResetClearSelectedRowsFlag = new EventEmitter<boolean>(); // Emitter to reset the clear flag in parent after clearing selected rows in child component
   // (Child to Parent) One-way event binding for selected rows
   @Output() childSelectedRowUpdate = new EventEmitter(); // Selected rows will ONLY be emitted to parent, and NOT received from parent

   // NAV Reconciliation OPS filter varaibles
   navReconSignOffStatusList: string[] = [];
   navReconStatusList: string[] = [];
   navReconEntityList: string[] = [];
   navReconOPSFundTypeList: string[] = [];
   navReconCustodianReconPartyList: string[] = [];
   navReconNAVFrequencyList: string[] = [];
   navReconSLATypeList: string[] = [];
   navReconSLAMetList: string[] = [];
   // PDCC OPS filter varaibles
   pdccFundClassList: string[] = [];
   // D&C OPS filter variables
   dcSignOffStatusList: string[] = [];
   dcTradeFillDayList: string[] = [];
   dcDealingDateIndicatorList: string[] = [];
   dcFundGroupList: string[] = [];
   dcCalcTypeList: string[] = [];
   dcCustodianReconPartyList: string[] = [];

   rowGroupMetadata: any = {};
   @Output() updateParentData = new EventEmitter();
   @ViewChild(Calendar, { static: false }) calendar: Calendar | undefined;
   @Input() source: any;
   @Input() reconType: any;
   @Output() filteredFundsCount = new EventEmitter();
   @Output() showStatusReport = new EventEmitter();
   @Output() editInCash = new EventEmitter();
   @Output() editInParentRow = new EventEmitter();
   @Output() editParentAggregatedRow = new EventEmitter();
   @Output() editCell = new EventEmitter();
   @Output() editDcCell = new EventEmitter();
   @Output() deleteFromParent = new EventEmitter();
   @Output() deleteParentAggregatedRow = new EventEmitter();
   @Output() changeIPSwitch = new EventEmitter()
   editdc: boolean = false;
   check: any;
   inKindOptions: any=[]
   typeOptions: any=[]
   dropoptions: any=[]
   target: any;
   status: any;
   filterValues: { [key: string]: any } = {};
   emptyMessage: string = "No records found.";

   // Calendar values
   date: Date | null = null;
   date1: Date | null = null;

   constructor(
      private datePipe: DatePipe, public defaultService: DefaultService, public messageService: MessageService,
      private cdr: ChangeDetectorRef
   ) { }

   opts = [{ label: 'hi', value: 'hi' }]

   ngOnInit() {
      localStorage.removeItem('tablefilters');
      localStorage.removeItem('dateObj');
      localStorage.removeItem('selectedRows');
      this.editdc = false;
      // On intialization, make a copy of the input tableData for computation within the component, and keep the original intact for reference and reset purposes.
      this.copyTableData = [...this.tableData];
      if (this.tableData?.length > 0) { this.updateRowGroupMetaData(this.tableData); }
      this.getDropdownOptions();
   }

   clearOpsFiltersLists() {
      // NAV Reconciliation OPS filter varaibles
      this.navReconSignOffStatusList = [];
      this.navReconStatusList = [];
      this.navReconEntityList = [];
      this.navReconOPSFundTypeList = [];
      this.navReconCustodianReconPartyList = [];
      this.navReconNAVFrequencyList = [];
      this.navReconSLATypeList = [];
      this.navReconSLAMetList = [];
      // PDCC OPS filter varaibles
      this.pdccFundClassList = [];
      // D&C OPS filter variables
      this.dcSignOffStatusList = [];
      this.dcTradeFillDayList = [];
      this.dcDealingDateIndicatorList = [];
      this.dcFundGroupList = [];
      this.dcCalcTypeList = [];
      this.dcCustodianReconPartyList = [];
   }

   onEditInit(event: { field: any; data: { crCharges: any; signOffStatus: any; adjustmentFactor: any; threshold_breach_comments: any; sign_off_status: string; dcCalcType: any; inKindDepo: any; modelPrice: any}; }): void {
      this.check = null
      switch (event.field) {
         case 'crCharges':
            this.check = event.data.crCharges
            this.status = event.data.signOffStatus
            break;
         case 'adjustmentFactor':
            this.check =  event.data.adjustmentFactor
            this.status = event.data.signOffStatus
            break;
         case 'threshold_breach_comments':
            this.check = event.data.threshold_breach_comments
            this.status = event.data.sign_off_status == 'N' ? 'PEND' : ' SIGNED-OFF';
            break;
         case 'dcCalcType':
            this.check = event.data.dcCalcType
            this.status = event.data.signOffStatus
            break;
         case 'inKindDepo':
            this.check = event.data.inKindDepo
            this.status = event.data.signOffStatus
            break;
         case 'modelPrice':
            this.check = event.data.modelPrice
            this.status = event.data.signOffStatus
            break;
      }
   }

   onEditCancel(): void { }

   onEditComplete(event: any) {
      if (this.status == 'PEND') {
         this.target = event.originalEvent.target.toString();
         switch (event.field) {
            case 'inKindDepo':
               if (this.check !== event.data.inKindDepo) { 
                  this.editCell.emit({ data: event.data });
               } else if(this.check == event.data.inKindDepo) {
                  if (this.check == null || this.check == "") {
                     if (this.target == '[object HTMLSpanElement]' || this.target == ' [object HTMLLIElement] ') {
                        const reqValue = this.dropoptions[0].value;
                        event.data['inKindDepo'] = reqValue;
                        this.editCell.emit({ data: event.data });
                     }
                  }
               }
               break;
            case 'dcCalcType':
               if (this.check !== event.data.dcCalcType) {
                  this.editCell.emit({ data: event.data });
               } else if (this.check == event.data.dcCalcType) {
                  if (this.check == null || this.check == "") {
                     if (this.target == '[object HTMLSpanElement]' ||this.target == ' [object HTMLLIElement] ') {
                        const reqValue = event.data.dcCalcTypeArray[0].value;
                        event.data['dcCalcType'] = reqValue;
                        this.editCell.emit({ data: event.data });
                     }
                  }  
               }
               break;
            case 'crCharges': if (this.check !== event.data.crCharges) { this.editCell.emit({ data: event.data }) } break;
            case 'adjustmentFactor': if (this.check !== event.data.adjustmentFactor) { this.editCell.emit({ data: event.data }) } break;
            case 'modelPrice' : if (this.check !== event.data.modelPrice) { this.editCell.emit({ data: event.data })} break;
         }
      }
      if (event.field === 'threshold_breach_comments') {
         if (this.check !== event.data.threshold_breach_comments ){ this.editCell.emit({data:event.data}) }
      }
   }

   // Detect changes for @Input properties and handle them accordingly
   ngOnChanges(changes: SimpleChanges) {
      // tableData (parent to child one-way property binding) changes handling
      if (changes.tableData && !changes.tableData.firstChange) {
         if (changes.tableData.previousValue !== changes.tableData.currentValue) {
            this.tableData = [...changes.tableData.currentValue];
            if (this.tableData.length > 0) { this.updateRowGroupMetaData(this.tableData); }
            // Update the copy of table data whenever the input tableData changes from parent
            this.copyTableData = [...this.tableData];
            // After table is loaded, apply existing filters
            if (this.copyTableData.length > 0) { this.onFilter({}, true); }
            // For FA Fund & Account pagination handling
            if (this.source === 'fa_fund_acct') { this.updatePagedTableData(); }
         }
      }
      // isClearSelectedRows (two-way property binding) changes handling
      if (changes.isClearSelectedRows && !changes.isClearSelectedRows.firstChange) {
         if (changes.isClearSelectedRows.currentValue === true) {
            this.selectedRows = [];
            this.childSelectedRowUpdate.emit(this.selectedRows);
            this.childEmitResetClearSelectedRowsFlag.emit(); // Reset the flag after clearing selected rows
         }
      }
      // opsFilterOptions (parent to child one-way property binding) changes handling
      if (changes.opsFilterOptions && !changes.opsFilterOptions.firstChange) {
         // Clear the existing filter settings before applying new filter settings
         this.filterValues = {};
         this.clearOpsFiltersLists();
         // Apply existing merge table filters that are not from the OPS Filter component
         if (this.date != null) {
            let dateFilterValue: string | null = this.datePipe.transform(this.date, 'dd MMM YYYY');
            if (dateFilterValue) { this.addValueToFilterSettings(dateFilterValue, 'dealingDate', 'equals'); }
         }
         // Additionally, apply the filter settings that comes from the OPS Filter component
         for (const [filterKey, filterValueList] of Object.entries(changes.opsFilterOptions.currentValue)) {
            if (!Array.isArray(filterValueList)) {
               // console.log("Merge Table - ngOnChanges - filter value list for filter key: ", filterKey, " is not an array, skipping filter application for this key");
               continue;
            }
            if (filterValueList.length === 0) {
               // console.log("Merge Table - ngOnChanges - filter key: ", filterKey, " EMPTY filter value list: ", filterValueList);
               continue;
            }
            switch (filterKey) {
               ///  NAV Reconciliation OPS filters  \\\
               case "sign_off_status":
                  this.navReconSignOffStatusList = filterValueList.map((filterValue: any) => filterValue.toUpperCase());
                  this.addArrayValuesToFilterSettings(this.navReconSignOffStatusList, 'sign_off_status', 'contains');
                  break;
               case "recon_status":
                  this.navReconStatusList = filterValueList.map((filterValue: any) => filterValue.toUpperCase());
                  this.addArrayValuesToFilterSettings(this.navReconStatusList, 'recon_status', 'contains');
                  break;
               case "entity":
                  this.navReconEntityList = filterValueList.map((filterValue: any) => filterValue.toUpperCase());
                  this.addArrayValuesToFilterSettings(this.navReconEntityList, 'entity', 'contains');
                  break;
               case "ops_fund_type":
                  this.navReconOPSFundTypeList = filterValueList.map((filterValue: any) => filterValue.toUpperCase());
                  this.addArrayValuesToFilterSettings(this.navReconOPSFundTypeList, 'ops_fund_type', 'contains');
                  break;
               case "custodian_recon_party":
                  this.navReconCustodianReconPartyList = filterValueList.map((filterValue: any) => filterValue.toUpperCase());
                  this.addArrayValuesToFilterSettings(this.navReconCustodianReconPartyList, 'custodian_recon_party', 'contains');
                  break;
               case "nav_frequency":
                  this.navReconNAVFrequencyList = filterValueList.map((filterValue: any) => filterValue.toUpperCase());
                  this.addArrayValuesToFilterSettings(this.navReconNAVFrequencyList, 'nav_frequency', 'contains');
                  break;
               case "sla_type":
                  this.navReconSLATypeList = filterValueList.map((filterValue: any) => filterValue.toUpperCase());
                  this.addArrayValuesToFilterSettings(this.navReconSLATypeList, 'sla_type', 'contains');
                  break;
               case "sla_met":
                  this.navReconSLAMetList = filterValueList.map((filterValue: any) => filterValue.toUpperCase());
                  this.addArrayValuesToFilterSettings(this.navReconSLAMetList, 'sla_met', 'contains');
                  break;
               ///  PDCC OPS filters  \\\
               case "fund_class":
                  this.pdccFundClassList = filterValueList.map((filterValue: any) => filterValue.toUpperCase());
                  this.addArrayValuesToFilterSettings(this.pdccFundClassList, 'fund_class', 'contains');
                  break;
               ///  D&C OPS filters  \\\
               case "tradeFillDay":
                  this.dcTradeFillDayList = filterValueList.map((filterValue: any) => filterValue.toUpperCase());
                  this.addArrayValuesToFilterSettings(this.dcTradeFillDayList, 'tradeFillDay', 'contains');
                  break;
               case "signOffStatusIndicator":
                  this.dcSignOffStatusList = [];
                  if (!Array.isArray(changes.opsFilterOptions.currentValue.tradeFillDay)) { break; }
                  for (const filterValue of filterValueList) {
                     switch (filterValue) {
                        case "SIGNED-OFF":
                           if (changes.opsFilterOptions.currentValue.tradeFillDay.includes('T0')) {
                              if (!this.dcSignOffStatusList.includes("T0S")) { this.dcSignOffStatusList.push("T0S"); }
                              if (!this.dcSignOffStatusList.includes("T0FS")) { this.dcSignOffStatusList.push("T0FS"); }
                           }
                           if (changes.opsFilterOptions.currentValue.tradeFillDay.includes('T1')) {
                              if (!this.dcSignOffStatusList.includes("T1S")) { this.dcSignOffStatusList.push("T1S"); }
                              if (!this.dcSignOffStatusList.includes("T1FS")) { this.dcSignOffStatusList.push("T1FS"); }
                           }
                           if (changes.opsFilterOptions.currentValue.tradeFillDay.includes('T2')) {
                              if (!this.dcSignOffStatusList.includes("T2FS")) { this.dcSignOffStatusList.push("T2FS"); }
                           }
                           break;
                        case "PENDING":
                           if (!this.dcSignOffStatusList.includes("PEND")) { this.dcSignOffStatusList.push("PEND"); }
                           break;
                     }
                  }
                  this.addArrayValuesToFilterSettings(this.dcSignOffStatusList, 'signOffStatus', 'contains');
                  break;
               case "dealingDateIndicator":
                  this.dcDealingDateIndicatorList = filterValueList.map((filterValue: any) => filterValue.toUpperCase());
                  this.addArrayValuesToFilterSettings(this.dcDealingDateIndicatorList, 'dealingDateIndicator', 'contains');
                  break;
               case "fundGroup":
                  this.dcFundGroupList = filterValueList.map((filterValue: any) => filterValue.toUpperCase());
                  this.addArrayValuesToFilterSettings(this.dcFundGroupList, 'fundGroup', 'contains');
                  break;
               case "dcCalcType":
                  this.dcCalcTypeList = filterValueList.map((filterValue: any) => filterValue.toUpperCase());
                  this.addArrayValuesToFilterSettings(this.dcCalcTypeList, 'dcCalcType', 'contains');
                  break;
               case "custodianReconParty":
                  this.dcCustodianReconPartyList = filterValueList.map((filterValue: any) => filterValue.toUpperCase());
                  this.addArrayValuesToFilterSettings(this.dcCustodianReconPartyList, 'custodianReconParty', 'contains');
                  break;
            }
         }
         this.onFilter();
      }
   }

   thousandSeparators(value: any) { return thousands_separators(value); }
   thousandSeparatorsDecimal(value: any) { return thousands_separatorsd(value); }

   onClickCashComp(file: any) {
      let selectedFund = [];
      selectedFund.push(file);
      localStorage.setItem('selectedRows', JSON.stringify(selectedFund));
      this.editInCash.emit(file);
   }

   onClickStatus(fileStatus: string | any[]) {
      if (fileStatus.length === 0) { return; }
      this.showStatusReport.emit(fileStatus);
   }

   calculateCount(list: any[]) {
      const fList: any[] = [];
      switch (this.reconType) {
         case 'D&C': list?.forEach((d: any) => { if (d.orderId) { fList.push(d.orderId); } }); break;
         default: list?.forEach((d: any) => { if (d.tradar_code) { fList.push(d.tradar_code); } }); break;
      }
      const finalList = [...new Set(fList.map(item => item))];
      return finalList.length;
   }

   deepEqual(a: any, b: any): boolean {
      if (a === b) return true;
      if (typeof a !== typeof b) return false;
      if (a === null || b === null) return a === b;
      if (typeof a !== "object") return a === b;

      if (Array.isArray(a)) {
         if (!Array.isArray(b) || a.length !== b.length) return false;
         for (let i = 0; i < a.length; i++) {
            if (!this.deepEqual(a[i], b[i])) return false;
         }
         return true;
      }

      const aKeys = Object.keys(a);
      const bKeys = Object.keys(b);
      if (aKeys.length !== bKeys.length) return false;

      for (const key of aKeys) {
         if (!b.hasOwnProperty(key)) return false;
         if (!this.deepEqual(a[key], b[key])) return false;
      }
      return true;
   }

   onFilterInput(value: string, field: string, matchMode: string): void {
      // Override the matchMode filter settings if the table filters has existing setting
      if (this.dt?.filters[field]) {
         const existingTableFilterMetadata: any = this.dt.filters[field];
         matchMode = existingTableFilterMetadata?.matchMode || matchMode;
      }
      this.filterValues[field] = { value, matchMode };
      this.onFilter();
   }

   addValueToFilterSettings(value: string, field: string, matchMode: string): void {
      this.filterValues[field] = { value, matchMode };
   }

   addArrayValuesToFilterSettings(value: any[], field: string, matchMode: string): void {
      if (Array.isArray(value) && value.length > 0) {
         if (matchMode === 'contains') {
            // Escape regex special characters in each value
            const escaped = value.map(v => v.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
            // Join with | for OR matching
            const regexString = escaped.join('|');
            this.filterValues[field] = { value: regexString, matchMode, isRegex: true };
         }
      } else {
         console.log("addArrayValuesToFilterSettings - Invalid array or is empty:", value);
      }
   }

   /**
    * The (onFilter) event is emitted when the table's data is filtered. The event object ($event) contains a "filteredValue" property, 
    * which is an array of the data remaining after the filter is applied. 
    * @param event 
    */
   previousFilters: object | null = null; // Store the previous filters to compare with new filters
   onFilter(event: any = {}, isOverridePrevFilterCheck: boolean = false) {
      if (this.previousFilters != null) {
         let isSkipFilterRender = this.deepEqual(this.previousFilters, this.filterValues);
         if (isSkipFilterRender && !isOverridePrevFilterCheck) { 
            // console.log("Merge Table - onFilter - Skipping filter application and table update as the new filters are deeply equal to the previous filters. filterValues: ", this.filterValues);
            return;
         }
      }
      if (!isOverridePrevFilterCheck) { this.previousFilters = JSON.parse(JSON.stringify(this.filterValues)); }

      // Start with / Reset to the original table data before applying filters
      let filteredTableData = [...this.copyTableData];

      if (Object.keys(this.filterValues).length > 0) {
         for (const [columnFieldName, filterSettings] of Object.entries(this.filterValues)) {
            switch (typeof filterSettings) {
               case "object":
                  const filterValue = (filterSettings as any).value;
                  // If filter value is null or undefined, it means the filter is cleared, so we ignore it
                  if (filterValue === null || filterValue === undefined || filterValue === '') { continue; }

                  filteredTableData = filteredTableData.filter((row: any) => {
                     let rowValue = row[columnFieldName];
                     if (rowValue === null || rowValue === undefined) { return false; }
                     let isValidDate = !isNaN(new Date(rowValue).getTime());
                     if (isValidDate) { rowValue = this.datePipe.transform(rowValue, 'dd MMM YYYY'); }
                     const rowUpperCaseStr = rowValue.toString().toUpperCase();
                     const filterUpperCaseStr = filterValue.toString().toUpperCase();
                     if (Object.prototype.hasOwnProperty.call(filterSettings, 'matchMode')) {
                        switch ((filterSettings as any).matchMode) {
                           case 'contains': 
                              if ((filterSettings as any).isRegex) {
                              // Use regex for matching
                              const regex = new RegExp(filterUpperCaseStr, 'i');
                              return regex.test(rowUpperCaseStr);
                           } else {
                              // Fallback to includes
                              return rowUpperCaseStr.includes(filterUpperCaseStr);
                           }
                           case 'notContains': return !rowUpperCaseStr.includes(filterUpperCaseStr);
                           case 'startsWith': return rowUpperCaseStr.startsWith(filterUpperCaseStr);
                           case 'endsWith': return rowUpperCaseStr.endsWith(filterUpperCaseStr);
                           case 'equals': return rowUpperCaseStr === filterUpperCaseStr;
                           case 'notEquals': return rowUpperCaseStr !== filterUpperCaseStr;
                           default: console.log("Merge table - onFilter matchMode: ", (filterSettings as any).matchMode, " is not supported for filtering in merge table");
                        }
                     } else { console.log("Merge table - onFilter no matchMode provided in filterSettings, cannot apply filter for rowValue: ", rowValue, " and filterValue: ", filterValue); }
                  });
                  break;
               default: console.log(typeof filterSettings, "is not supported for filtering in merge table"); break;
            }
         }
      }

      this.isLoading = true;
      
      // Assign the filtered data to tableData (new reference)
      this.tableData = [...filteredTableData];
      this.updateRowGroupMetaData(this.tableData);
      
      // Filter selectedRows to retain only those present in filteredData
      this.selectedRows = this.selectedRows.filter(selected => this.tableData.includes(selected));
      this.childSelectedRowUpdate.emit([...this.selectedRows]);

      // For FA Fund & Account pagination handling
      if (this.source === 'fa_fund_acct') { this.updatePagedTableData(); }

      this.filteredFundsCount.emit(this.calculateCount(this.tableData));

      // Force change detection to update the table view
      this.cdr.detectChanges();
      this.cdr.markForCheck();
   }

   tableOnfilter(e: any, val: string | number) {
      let cachedTableFilterList: any = localStorage.getItem('tablefilters');
      let tablefilters: any = JSON.parse(cachedTableFilterList) || {};
      let records: any;
      val = val.toString();
      tablefilters[val] = e;
      if (!tablefilters?.tradar_code && !tablefilters?.ticker) records = this.copyTableData;
      else if (tablefilters?.tradar_code && tablefilters?.ticker) records = this.copyTableData?.filter((v: { tradar_code: any; ticker: any; }) => v.tradar_code == tablefilters?.tradar_code && v.ticker == tablefilters?.ticker);
      else if (tablefilters?.tradar_code && !tablefilters?.ticker) records = this.copyTableData?.filter((v: { tradar_code: any; }) => v.tradar_code == tablefilters?.tradar_code);
      else if (!tablefilters?.tradar_code && tablefilters?.ticker) records = this.copyTableData?.filter((v: { ticker: any; }) => v.ticker == tablefilters?.ticker);
      localStorage.setItem('tablefilters', JSON.stringify(tablefilters));
      setTimeout(() => {
         this.tableData = [...records];
         if (this.tableData?.length > 0) this.updateRowGroupMetaData(this.tableData);
         // Force change detection to update the table view
         this.cdr.detectChanges();
      });
   }

   updateRowGroupMetaData(data: any) {
      this.rowGroupMetadata = {};
      if (!data || data.length === 0) {
         this.isLoading = false;
         console.log("Merge table - No data to process for row grouping.");
         return;
      }
      for (let i = 0; i < data.length; i++) {
         const rowData = data[i];
         let metaKey = rowData?.fund_id;
         if (this.reconType == 'D&C') { metaKey = rowData.orderId; }
         switch (this.source) {
            case 'tdte': case 'tdthreshold': metaKey = rowData.fund_type; break;
            case 'fa_fund_acct': metaKey = rowData.pma_fund_code; break;
         }
         if (i == 0) {
            this.rowGroupMetadata[metaKey] = { index: 0, size: 1 };
         } else {
            const previousRowData = data[i - 1];
            let previousRowMetaKey = previousRowData?.fund_id;
            if (this.reconType == 'D&C') { previousRowMetaKey = previousRowData.orderId; }
            switch (this.source) {
               case 'tdte': case 'tdthreshold': previousRowMetaKey = previousRowData.fund_type; break;
               case 'fa_fund_acct': previousRowMetaKey = previousRowData.pma_fund_code; break;
            }
            if (metaKey === previousRowMetaKey) {
               this.rowGroupMetadata[metaKey].size++;
            } else {
               this.rowGroupMetadata[metaKey] = { index: i, size: 1 };
            }
         }
      }
      this.isLoading = false;

      // Force change detection to update the table view
      this.cdr.markForCheck();
   }

   onClickRowDetail(rowData: any) {
      let selectedFund = [];
      selectedFund.push(rowData);
      localStorage.setItem('selectedRows', JSON.stringify(selectedFund));
      this.selectedRows = selectedFund; // Update the component's selectedRows with the row that was clicked
      this.childSelectedRowUpdate.emit(this.selectedRows); // Emit the updated selected rows to the parent component
      this.editInParent.emit(rowData);
   }

   customSort(e: any) {
      if (this.source == 'tdte') {
         this.tableData.sort((a, b) => {
            if (a[e.field] < b[e.field]) {
               return -1 * e.order;
            } else if (a[e.field] > b[e.field]) {
               return 1 * e.order;
            } else {
               return 0;
            }
         });
         this.tableData.sort((a, b) => {
            if (a['fund_type'] < b['fund_type']) {
               return -1 * e.order;
            } else if (a['fund_type'] > b['fund_type']) {
               return 1 * e.order;
            } else {
               return 0;
            }
         });
         this.tableData = [...this.tableData];
         this.updateRowGroupMetaData(this.tableData);
      } else {
         this.tableData.sort((a, b) => {
            if (a[e.field] < b[e.field]) {
               return -1 * e.order;
            } else if (a[e.field] > b[e.field]) {
               return 1 * e.order;
            } else {
               return 0;
            }
         });
         this.tableData = [...this.tableData];
         this.updateRowGroupMetaData(this.tableData);
      }
   }

   onSelectDate(date: string | number | Date, field: string | number) {
      let filteredDt: any[] = [];
      if (date) {
         const dt = this.datePipe.transform(date, 'dd MMM YYYY');
         filteredDt = this.copyTableData.filter((d: any) => {
            const signOffDate = this.datePipe.transform(d[field], 'dd MMM YYYY');
            if (signOffDate == dt) { return d; }
         });
         const cachedDateObj: any = localStorage.getItem('dateObj');
         let dateObj = JSON.parse(cachedDateObj) || {};
         dateObj[field] = dt;
         localStorage.setItem('dateObj', JSON.stringify(dateObj));
         setTimeout(() => {
            this.tableData = filteredDt;
            this.updateRowGroupMetaData(this.tableData);
         });
      }
   }

   onClickClose(field: string | number) {
      const cachedDateObj: any = localStorage.getItem('dateObj');
      let dateObj = JSON.parse(cachedDateObj) || {};
      delete dateObj[field]
      localStorage.setItem('dateObj', JSON.stringify(dateObj));
      setTimeout(() => {
         this.updateParentData.emit();
         this.tableData = [...this.copyTableData];
         this.updateRowGroupMetaData(this.tableData);
      });
   }

   onClickAggregateRowEdit(row: any) {
      let rowAggregateIdentifier = row?.fund_id;
      if (this.source == 'fa_fund_acct') {
         rowAggregateIdentifier = row?.pma_fund_code;
      }
      if (!rowAggregateIdentifier) {
         console.log("Merge table - No aggregate identifier found to edit for row: ", row);
         return;
      }
      this.editParentAggregatedRow.emit(rowAggregateIdentifier);
   }

   // (Child to Parent) One-way event binding update for selected rows
   // "selectedRows" will always contain the latest selected rows from the table due to [(selection)]="selectedRows" binding
   onSelectRow() { this.childSelectedRowUpdate.emit([...this.selectedRows]); }
   onRowUnselect() { this.childSelectedRowUpdate.emit([...this.selectedRows]); }
   selectAllRows() { this.childSelectedRowUpdate.emit([...this.selectedRows]); }

   onClickEdit(row: any, index: any) { this.editInParentRow.emit({ row: row, index: index }); }
   onDeleteClick(data: any, index: any) { this.deleteFromParent.emit({ row: data, index: index }); }

   onClickAggregateRowDelete(row: any) {
      let rowAggregateIdentifier = row?.fund_id;
      if (this.source == 'fa_fund_acct') { rowAggregateIdentifier = row?.pma_fund_code; }
      if (!rowAggregateIdentifier) {
         console.log("Merge table - No aggregate identifier found to delete for row: ", row);
         return;
      }
      this.deleteParentAggregatedRow.emit(rowAggregateIdentifier);
   }

   changeInputSwitch(event: any, id: any, rowData: any) { this.changeIPSwitch.emit({ event: event, id: id, rowData: rowData }); }

   getAbsValue(value: number) { return value ? value * 100 : 0; }

   getDropdownOptions() {
      this.defaultService.dcfindEn({ queryParams: { "category": { "equals": ["Depo"] } }, orderByParams: { category: 'asc', code: 'asc' } }, 1, 1000, `common/enums/getall`).then((data: any) => {
         if (data && data.status === 'success') {
            const enumType = data.data;
            enumType.forEach((element: { [x: string]: any; }) => {
               this.inKindOptions.push(element)
               this.typeOptions.push({ label: element['code_desc'], value: element['code'] });
               this.dropoptions = this.typeOptions
            });
            this.dropoptions.unshift({ label: 'None', value: null })
         } else {
            this.messageService.add({ severity: 'error', detail: data.status });
         }
      }).catch((err: any) => { this.messageService.add({ severity: 'error', detail: err }); });
    }

    // Check if any of a group of fundID's data rows has 'NOT RECONCILED' status
    hasNotReconciledStatusInGroup(fundId: any): boolean {
      return this.tableData
        .filter(row => row.fund_id === fundId)
        .some(row => row.recon_status === 'NOT RECONCILED');
    }
  
    // Get the reconciliation status for a group of fundID's data rows based on their' status
    getGroupReconciliationStatus(fundId: any): string {
      const hasNotReconciled = this.tableData
        .filter(row => row.fund_id === fundId)
        .some(row => row.recon_status === 'NOT RECONCILED');
      
      return hasNotReconciled ? 'NOT RECONCILED' : 'RECONCILED';
   }

   // ========================================================================
   //   Grouped pagination page change handler (For FA Fund & Account table)  
   // ========================================================================
   pagedTableData: any[] = [];
   currentPage: number = 0;
   groupsPerPage: number = 10; // Number of groups per page

   updatePagedTableData() {
      const groupMap = new Map<string, any[]>();
      for (const row of this.tableData) {
         const key = row.pma_fund_code;
         if (!groupMap.has(key)) { groupMap.set(key, []); }
         groupMap.get(key)?.push(row);
      }
      const groups = Array.from(groupMap.values());
      const start = this.currentPage * this.groupsPerPage;
      const end = start + this.groupsPerPage;
      this.pagedTableData = groups.slice(start, end).flat();
      this.updateRowGroupMetaData(this.pagedTableData);
   }

   // Count unique pma_fund_code values
   get totalGroupCount() { return new Set(this.tableData.map(row => row.pma_fund_code)).size; }

   // Call this when paginator changes
   onGroupPageChange(event: any) {
      this.currentPage = event.page; 
      this.updatePagedTableData();
   }
}